export default __webpack_public_path__ + "static/media/userIcon.37212b41.svg";